import Axios from './axios';

// 自动获取当前窗口的 origin 并拼接 API 路径
const getBaseURL = (): string => {
  // 获取当前窗口的协议、主机和端口
  const { protocol, hostname, port } = window.location;
  
  // 构建基础 URL
  let baseURL = `${protocol}//${hostname}`;
  
  // 如果有端口号且不是默认端口，添加端口号
  if (port && port !== '80' && port !== '443') {
    baseURL += `:${port}`;
  }
  
  // 添加 API 路径前缀
  
  return baseURL;
};

// 创建实例
const api = new Axios(getBaseURL());

export default api;